<template>
  <div class="page">
    <Navigation />

    <main class="page__wrap">
      <v-container
        class="mainContainer mainContainer--full responsiveGutters content"
      >
        <slot></slot>
      </v-container>
    </main>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/organisms/footer/Footer.vue'
import Navigation from '@/components/organisms/navigation/navigation.vue'

export default {
  name: 'WideLayout',

  components: {
    Navigation,
    Footer,
  },
}
</script>
